import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form } from 'react-bootstrap';

import Select from 'react-select';

import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign, faEdit, faShareSquare, faCloudDownloadAlt, faCloudUploadAlt, faMoneyBill, faClipboardCheck, faEye, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { faUniversity } from '@fortawesome/free-solid-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import EnquiryView from './EnquiryView';

import * as Common from '../Common';
import Dialog from '../Dialog';

function EnquiryList() {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [userRight, setUserRight] = useState([]);
    const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const [srchRef, setSrchRef] = useState("");
    const [reqFrom, setReqFrom] = useState(new Date());
    const [reqTo, setReqTo] = useState(new Date());
    const [reqStatus, setReqStatus] = useState("A");
    const [ddReqStatusOptions, setDdReqStatusOptions] = useState([]);

    const [reqBran, setReqBran] = useState("0");
    const [ddReqBranOptions, setDdReqBranOptions] = useState([]);
    const [reqBranSelect, setReqBranSelect] = useState([]);

    const [tranListData, setTranListData] = useState([]);

    const [showListWindow, setShowListWindow] = useState(true);
    const [showFromDetail, setShowFormDetail] = useState(false);

    const [modalRef, setModalRef] = useState("");
    const [srchAutoRefresh, setSrchAutoRefresh] = useState(false);

    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [reqAgentName, setReqAgentName] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'ENQUIRYLIST'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    setDdReqStatusOptions(
                        [
                            { "value": "A", "name": "ALL" },
                            { "value": "E", "name": "Lead" },
                            { "value": "C", "name": "Engaged" },
                            { "value": "N", "name": "Not Interested" },
                            { "value": "R", "name": "Not Executed" },
                            { "value": "D", "name": "Completed" }
                        ]
                    );
                    // branchallselect
                    /*
                        { "value": "N", "name": "Not Interested" },
                            { "value": "I", "name": "In Process" },
                        -- E Enquiry  
                        -- C confirmed
                        -- R Rejected
                        -- N Not Interested
                    */
                    if (sessionStorage.entityType === "A") {
                        setDdReqAgentOptions([{ label: sessionStorage.entityname, value: sessionStorage.entityId }]);
                        onChangeAgent(sessionStorage.entityId, sessionStorage.entityname);
                    }
                    if (sessionStorage.entityType === "B") {
                        Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentselect'], function (result) {
                            let resp = JSON.parse(result);
                            console.log(resp);
                            setDdReqAgentOptions(resp);
                        });
                    }
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, entityType]);

    function getList() {
        setTranListData([]);
        var object1 = {
            reqFrom: Common.dateYMD(reqFrom),
            reqTo: Common.dateYMD(reqTo),
            reqStatus: reqStatus,
            reqBran: reqBran,
            reqSearch: srchRef,
            reqAgent: reqAgent,
        }
        Common.callApi(Common.apiEnquiry, [sid, 'list', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.length === 0) {
                setMsgText("No enquiry found.");
                setMsgBox(true);
            } else {
                setTranListData(resp);
                setRefreshCounter(refreshCounter + 1);
            }
        });
    }

    function handleReqBranchOptions(v) {
        setReqBranSelect(v);
        setReqBran(v.value);
    }

    function onChangeSearchStatus(v) {
        setReqStatus(v);
        setTranListData([]);
        setRefreshCounter(refreshCounter + 1);
    }

    function showDetailViewWindow(v) {
        setModalRef(v);
        setShowListWindow(false);
        setShowFormDetail(true);
    }

    function btnBackClick() {
        setShowListWindow(true);
        setShowFormDetail(false);
        getList();
    }

    function handleAutoRefresh() {
        clearInterval(sessionStorage.myInterval);
        if (!srchAutoRefresh) {
            sessionStorage.myInterval = setInterval(() => document.getElementById("btnSearchRequest").click(), 30000);
        }
        setSrchAutoRefresh(!srchAutoRefresh);

    }

    function showSearchOptions() {
        setMsgText("Search on : Serial Number, Name, Mobile, UID");
        setMsgBox(true);
    }

    function onChangeAgent(id, agnname) {
        setReqAgent(id);
        setReqAgentName(agnname);
        // setReqAgentLocation("0");
        // Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentlocation', 'A', id], function (result) {
        //     setDdReqAgentLocationOptions(JSON.parse(result));
        // });
    }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >

                {
                    showListWindow ? <>
                        <Row>
                            {
                                entityType === "B" ? <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Location</Form.Label>
                                            <Select
                                                value={reqBranSelect}
                                                onChange={handleReqBranchOptions}
                                                options={ddReqBranOptions}
                                            />
                                        </Form.Group>
                                    </Col>
                                </> : null
                            }
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                    <Form.Select
                                        value={reqAgent}
                                        onChange={(e) => onChangeAgent(e.target.value, e.target[e.target.selectedIndex].text)}
                                        disabled={entityType === 'A'} >
                                        {ddReqAgentOptions.map((res) =>
                                            <option key={res.value} value={res.value}>{res.label}</option>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>

                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Search...<span className="handCursor colorThemeBlue" title="Help"
                                        onClick={(e) => showSearchOptions()}><FontAwesomeIcon icon={faInfoCircle} />
                                    </span></Form.Label>
                                    <Form.Control type="text" placeholder="Search..."
                                        maxLength={50} autoComplete="off"
                                        value={srchRef}
                                        onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSrchRef)}
                                    />
                                </Form.Group>
                            </Col>
                            {
                                srchRef.trim() === "" ? <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select
                                                value={reqStatus}
                                                onChange={(e) => onChangeSearchStatus(e.target.value)}  >
                                                {ddReqStatusOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>From Date</Form.Label>
                                            <DatePicker className="form-control"
                                                selected={reqFrom}
                                                onChange={(date) => setReqFrom(date)}
                                                isClearable
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>To Date</Form.Label>
                                            <DatePicker className="form-control"
                                                selected={reqTo}
                                                onChange={(date) => setReqTo(date)}
                                                isClearable
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </> : <>
                                    <Col>&nbsp;</Col>
                                    <Col>&nbsp;</Col>
                                    <Col>&nbsp;</Col>
                                </>
                            }
                        </Row>

                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col xs={12}>
                                <Button id="btnSearchRequest" variant="outline-primary" size="sm" onClick={() => getList()}>List</Button>&nbsp;
                                <input
                                    type="checkbox"
                                    checked={srchAutoRefresh}
                                    onChange={handleAutoRefresh}
                                />
                                &nbsp;Auto Refresh (30 seconds)&nbsp;
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        {
                            tranListData.length > 0 ? <>
                                <Row>
                                    <Col>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <td>Sr. No</td>
                                                    <td>Time</td>
                                                    <td>Agent</td>
                                                    <td>Branch</td>
                                                    <td>Name</td>
                                                    <td>Mobile</td>
                                                    <td>UID</td>
                                                    <td>Status</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody id="searchList">
                                                {tranListData.map((res) =>
                                                    <>
                                                        <tr key={res.enq_srno} >
                                                            <td className="textRight">{res.enq_srno}</td>
                                                            <td>{res.enq_timestamp}</td>
                                                            {
                                                                res.enq_agentcode * 1 > 0 ?
                                                                    <>
                                                                        <td>{res.enq_agentcode} : {res.entity_name_agent}&nbsp;{res.mel_location}</td>
                                                                    </> : <td>&nbsp;</td>
                                                            }
                                                            {
                                                                res.enq_branch * 1 > 0 ?
                                                                    <>
                                                                        <td>{res.enq_branch} : {res.entity_name_branch}</td>
                                                                    </> : <td>&nbsp;</td>
                                                            }
                                                            <td>{res.enq_name}</td>
                                                            <td>{res.enq_mobile}</td>
                                                            <td>{res.enq_loanacctno}</td>
                                                            <td>{res.enq_status}</td>
                                                            <td>
                                                                &nbsp;
                                                                <span className="handCursor colorThemeBlue"
                                                                    title="View Details"
                                                                    onClick={(e) => showDetailViewWindow(res.enq_srno)}
                                                                >
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>&nbsp;
                                                            </td>
                                                        </tr>
                                                    </>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </> : <></>
                        }
                    </> : <></>
                }
                {
                    showFromDetail ? <>
                        <Row>
                            <Col>
                                <Button id="btnSearchRequest" variant="outline-primary" size="sm" onClick={() => btnBackClick()}>
                                    Back
                                </Button>&nbsp;
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                <EnquiryView srno={modalRef} ></EnquiryView>
                            </Col>
                        </Row>
                        <Row><Col>&nbsp;</Col></Row>
                        <Row>
                            <Col>
                                <Button id="btnSearchRequest" variant="outline-primary" size="sm" onClick={() => btnBackClick()}>
                                    Back
                                </Button>&nbsp;
                            </Col>
                        </Row>
                    </> : <></>
                }

                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>
            </Container >
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <span className="corner-span">{refreshCounter}</span>
        </>
    )

}
export default EnquiryList;